import Oe, { useEffect as cr } from "react";
var Z = { exports: {} }, F = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _e;
function fr() {
  return _e || (_e = 1, process.env.NODE_ENV !== "production" && function() {
    var n = Oe, u = Symbol.for("react.element"), g = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), f = Symbol.for("react.strict_mode"), b = Symbol.for("react.profiler"), j = Symbol.for("react.provider"), _ = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), C = Symbol.for("react.suspense"), E = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), P = Symbol.for("react.lazy"), B = Symbol.for("react.offscreen"), Q = Symbol.iterator, ke = "@@iterator";
    function xe(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = Q && e[Q] || e[ke];
      return typeof r == "function" ? r : null;
    }
    var O = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function m(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
          t[o - 1] = arguments[o];
        je("error", e, t);
      }
    }
    function je(e, r, t) {
      {
        var o = O.ReactDebugCurrentFrame, s = o.getStackAddendum();
        s !== "" && (r += "%s", t = t.concat([s]));
        var c = t.map(function(l) {
          return String(l);
        });
        c.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, c);
      }
    }
    var Ae = !1, De = !1, Fe = !1, Ie = !1, Be = !1, ee;
    ee = Symbol.for("react.module.reference");
    function Me(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === a || e === b || Be || e === f || e === C || e === E || Ie || e === B || Ae || De || Fe || typeof e == "object" && e !== null && (e.$$typeof === P || e.$$typeof === w || e.$$typeof === j || e.$$typeof === _ || e.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === ee || e.getModuleId !== void 0));
    }
    function We(e, r, t) {
      var o = e.displayName;
      if (o)
        return o;
      var s = r.displayName || r.name || "";
      return s !== "" ? t + "(" + s + ")" : t;
    }
    function re(e) {
      return e.displayName || "Context";
    }
    function T(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && m("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case a:
          return "Fragment";
        case g:
          return "Portal";
        case b:
          return "Profiler";
        case f:
          return "StrictMode";
        case C:
          return "Suspense";
        case E:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case _:
            var r = e;
            return re(r) + ".Consumer";
          case j:
            var t = e;
            return re(t._context) + ".Provider";
          case h:
            return We(e, e.render, "ForwardRef");
          case w:
            var o = e.displayName || null;
            return o !== null ? o : T(e.type) || "Memo";
          case P: {
            var s = e, c = s._payload, l = s._init;
            try {
              return T(l(c));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var S = Object.assign, A = 0, ne, te, oe, ae, ie, le, ue;
    function se() {
    }
    se.__reactDisabledLog = !0;
    function Le() {
      {
        if (A === 0) {
          ne = console.log, te = console.info, oe = console.warn, ae = console.error, ie = console.group, le = console.groupCollapsed, ue = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: se,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        A++;
      }
    }
    function $e() {
      {
        if (A--, A === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: S({}, e, {
              value: ne
            }),
            info: S({}, e, {
              value: te
            }),
            warn: S({}, e, {
              value: oe
            }),
            error: S({}, e, {
              value: ae
            }),
            group: S({}, e, {
              value: ie
            }),
            groupCollapsed: S({}, e, {
              value: le
            }),
            groupEnd: S({}, e, {
              value: ue
            })
          });
        }
        A < 0 && m("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Y = O.ReactCurrentDispatcher, U;
    function M(e, r, t) {
      {
        if (U === void 0)
          try {
            throw Error();
          } catch (s) {
            var o = s.stack.trim().match(/\n( *(at )?)/);
            U = o && o[1] || "";
          }
        return `
` + U + e;
      }
    }
    var V = !1, W;
    {
      var Ne = typeof WeakMap == "function" ? WeakMap : Map;
      W = new Ne();
    }
    function ce(e, r) {
      if (!e || V)
        return "";
      {
        var t = W.get(e);
        if (t !== void 0)
          return t;
      }
      var o;
      V = !0;
      var s = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var c;
      c = Y.current, Y.current = null, Le();
      try {
        if (r) {
          var l = function() {
            throw Error();
          };
          if (Object.defineProperty(l.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(l, []);
            } catch (R) {
              o = R;
            }
            Reflect.construct(e, [], l);
          } else {
            try {
              l.call();
            } catch (R) {
              o = R;
            }
            e.call(l.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (R) {
            o = R;
          }
          e();
        }
      } catch (R) {
        if (R && o && typeof R.stack == "string") {
          for (var i = R.stack.split(`
`), p = o.stack.split(`
`), d = i.length - 1, v = p.length - 1; d >= 1 && v >= 0 && i[d] !== p[v]; )
            v--;
          for (; d >= 1 && v >= 0; d--, v--)
            if (i[d] !== p[v]) {
              if (d !== 1 || v !== 1)
                do
                  if (d--, v--, v < 0 || i[d] !== p[v]) {
                    var y = `
` + i[d].replace(" at new ", " at ");
                    return e.displayName && y.includes("<anonymous>") && (y = y.replace("<anonymous>", e.displayName)), typeof e == "function" && W.set(e, y), y;
                  }
                while (d >= 1 && v >= 0);
              break;
            }
        }
      } finally {
        V = !1, Y.current = c, $e(), Error.prepareStackTrace = s;
      }
      var x = e ? e.displayName || e.name : "", Re = x ? M(x) : "";
      return typeof e == "function" && W.set(e, Re), Re;
    }
    function Ye(e, r, t) {
      return ce(e, !1);
    }
    function Ue(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function L(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return ce(e, Ue(e));
      if (typeof e == "string")
        return M(e);
      switch (e) {
        case C:
          return M("Suspense");
        case E:
          return M("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case h:
            return Ye(e.render);
          case w:
            return L(e.type, r, t);
          case P: {
            var o = e, s = o._payload, c = o._init;
            try {
              return L(c(s), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var $ = Object.prototype.hasOwnProperty, fe = {}, de = O.ReactDebugCurrentFrame;
    function N(e) {
      if (e) {
        var r = e._owner, t = L(e.type, e._source, r ? r.type : null);
        de.setExtraStackFrame(t);
      } else
        de.setExtraStackFrame(null);
    }
    function Ve(e, r, t, o, s) {
      {
        var c = Function.call.bind($);
        for (var l in e)
          if (c(e, l)) {
            var i = void 0;
            try {
              if (typeof e[l] != "function") {
                var p = Error((o || "React class") + ": " + t + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw p.name = "Invariant Violation", p;
              }
              i = e[l](r, l, o, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (d) {
              i = d;
            }
            i && !(i instanceof Error) && (N(s), m("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", o || "React class", t, l, typeof i), N(null)), i instanceof Error && !(i.message in fe) && (fe[i.message] = !0, N(s), m("Failed %s type: %s", t, i.message), N(null));
          }
      }
    }
    var ze = Array.isArray;
    function z(e) {
      return ze(e);
    }
    function qe(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function He(e) {
      try {
        return ve(e), !1;
      } catch {
        return !0;
      }
    }
    function ve(e) {
      return "" + e;
    }
    function ge(e) {
      if (He(e))
        return m("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", qe(e)), ve(e);
    }
    var D = O.ReactCurrentOwner, Je = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, me, q;
    q = {};
    function Ge(e) {
      if ($.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Ke(e) {
      if ($.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Xe(e, r) {
      if (typeof e.ref == "string" && D.current && r && D.current.stateNode !== r) {
        var t = T(D.current.type);
        q[t] || (m('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', T(D.current.type), e.ref), q[t] = !0);
      }
    }
    function Ze(e, r) {
      {
        var t = function() {
          he || (he = !0, m("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function Qe(e, r) {
      {
        var t = function() {
          me || (me = !0, m("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var er = function(e, r, t, o, s, c, l) {
      var i = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: u,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: l,
        // Record the component responsible for creating this element.
        _owner: c
      };
      return i._store = {}, Object.defineProperty(i._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(i, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: o
      }), Object.defineProperty(i, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: s
      }), Object.freeze && (Object.freeze(i.props), Object.freeze(i)), i;
    };
    function rr(e, r, t, o, s) {
      {
        var c, l = {}, i = null, p = null;
        t !== void 0 && (ge(t), i = "" + t), Ke(r) && (ge(r.key), i = "" + r.key), Ge(r) && (p = r.ref, Xe(r, s));
        for (c in r)
          $.call(r, c) && !Je.hasOwnProperty(c) && (l[c] = r[c]);
        if (e && e.defaultProps) {
          var d = e.defaultProps;
          for (c in d)
            l[c] === void 0 && (l[c] = d[c]);
        }
        if (i || p) {
          var v = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          i && Ze(l, v), p && Qe(l, v);
        }
        return er(e, i, p, s, o, D.current, l);
      }
    }
    var H = O.ReactCurrentOwner, pe = O.ReactDebugCurrentFrame;
    function k(e) {
      if (e) {
        var r = e._owner, t = L(e.type, e._source, r ? r.type : null);
        pe.setExtraStackFrame(t);
      } else
        pe.setExtraStackFrame(null);
    }
    var J;
    J = !1;
    function G(e) {
      return typeof e == "object" && e !== null && e.$$typeof === u;
    }
    function Ee() {
      {
        if (H.current) {
          var e = T(H.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function nr(e) {
      {
        if (e !== void 0) {
          var r = e.fileName.replace(/^.*[\\\/]/, ""), t = e.lineNumber;
          return `

Check your code at ` + r + ":" + t + ".";
        }
        return "";
      }
    }
    var ye = {};
    function tr(e) {
      {
        var r = Ee();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function be(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = tr(r);
        if (ye[t])
          return;
        ye[t] = !0;
        var o = "";
        e && e._owner && e._owner !== H.current && (o = " It was passed a child from " + T(e._owner.type) + "."), k(e), m('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, o), k(null);
      }
    }
    function we(e, r) {
      {
        if (typeof e != "object")
          return;
        if (z(e))
          for (var t = 0; t < e.length; t++) {
            var o = e[t];
            G(o) && be(o, r);
          }
        else if (G(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var s = xe(e);
          if (typeof s == "function" && s !== e.entries)
            for (var c = s.call(e), l; !(l = c.next()).done; )
              G(l.value) && be(l.value, r);
        }
      }
    }
    function or(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === h || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === w))
          t = r.propTypes;
        else
          return;
        if (t) {
          var o = T(r);
          Ve(t, e.props, "prop", o, e);
        } else if (r.PropTypes !== void 0 && !J) {
          J = !0;
          var s = T(r);
          m("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", s || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && m("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ar(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var o = r[t];
          if (o !== "children" && o !== "key") {
            k(e), m("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", o), k(null);
            break;
          }
        }
        e.ref !== null && (k(e), m("Invalid attribute `ref` supplied to `React.Fragment`."), k(null));
      }
    }
    function Te(e, r, t, o, s, c) {
      {
        var l = Me(e);
        if (!l) {
          var i = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (i += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var p = nr(s);
          p ? i += p : i += Ee();
          var d;
          e === null ? d = "null" : z(e) ? d = "array" : e !== void 0 && e.$$typeof === u ? (d = "<" + (T(e.type) || "Unknown") + " />", i = " Did you accidentally export a JSX literal instead of a component?") : d = typeof e, m("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", d, i);
        }
        var v = rr(e, r, t, s, c);
        if (v == null)
          return v;
        if (l) {
          var y = r.children;
          if (y !== void 0)
            if (o)
              if (z(y)) {
                for (var x = 0; x < y.length; x++)
                  we(y[x], e);
                Object.freeze && Object.freeze(y);
              } else
                m("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              we(y, e);
        }
        return e === a ? ar(v) : or(v), v;
      }
    }
    function ir(e, r, t) {
      return Te(e, r, t, !0);
    }
    function lr(e, r, t) {
      return Te(e, r, t, !1);
    }
    var ur = lr, sr = ir;
    F.Fragment = a, F.jsx = ur, F.jsxs = sr;
  }()), F;
}
var I = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pe;
function dr() {
  if (Pe)
    return I;
  Pe = 1;
  var n = Oe, u = Symbol.for("react.element"), g = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, f = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, b = { key: !0, ref: !0, __self: !0, __source: !0 };
  function j(_, h, C) {
    var E, w = {}, P = null, B = null;
    C !== void 0 && (P = "" + C), h.key !== void 0 && (P = "" + h.key), h.ref !== void 0 && (B = h.ref);
    for (E in h)
      a.call(h, E) && !b.hasOwnProperty(E) && (w[E] = h[E]);
    if (_ && _.defaultProps)
      for (E in h = _.defaultProps, h)
        w[E] === void 0 && (w[E] = h[E]);
    return { $$typeof: u, type: _, key: P, ref: B, props: w, _owner: f.current };
  }
  return I.Fragment = g, I.jsx = j, I.jsxs = j, I;
}
process.env.NODE_ENV === "production" ? Z.exports = dr() : Z.exports = fr();
var vr = Z.exports;
function gr(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var hr = function(n, u, g) {
  var a = document.head || document.getElementsByTagName("head")[0], f = document.createElement("script");
  typeof u == "function" && (g = u, u = {}), u = u || {}, g = g || function() {
  }, f.type = u.type || "text/javascript", f.charset = u.charset || "utf8", f.async = "async" in u ? !!u.async : !0, f.src = n, u.attrs && mr(f, u.attrs), u.text && (f.text = "" + u.text);
  var b = "onload" in f ? Se : pr;
  b(f, g), f.onload || Se(f, g), a.appendChild(f);
};
function mr(n, u) {
  for (var g in u)
    n.setAttribute(g, u[g]);
}
function Se(n, u) {
  n.onload = function() {
    this.onerror = this.onload = null, u(null, n);
  }, n.onerror = function() {
    this.onerror = this.onload = null, u(new Error("Failed to load " + this.src), n);
  };
}
function pr(n, u) {
  n.onreadystatechange = function() {
    this.readyState != "complete" && this.readyState != "loaded" || (this.onreadystatechange = null, u(null, n));
  };
}
const Er = /* @__PURE__ */ gr(hr), yr = "https://d5aoblv5p04cg.cloudfront.net/editor-3/loader/build.js", br = "https://d5aoblv5p04cg.cloudfront.net/develop/loader/build.js", wr = "https://d5aoblv5p04cg.cloudfront.net/staging/loader/build.js";
function Tr(n = "production") {
  switch (n) {
    case "dev":
      return br;
    case "staging":
      return wr;
    default:
      return yr;
  }
}
const Ce = {
  init: (n, u) => new Promise((g, a) => {
    const f = Tr(u == null ? void 0 : u.stage);
    Er(f, (b) => {
      b !== null && a(b), window.TopolPlugin.init(n), g(!0);
    });
  }),
  save: () => {
    window.TopolPlugin.save();
  },
  load: (n) => {
    window.TopolPlugin.load(n);
  },
  togglePreview: () => {
    window.TopolPlugin.togglePreview();
  },
  togglePreviewSize: () => {
    window.TopolPlugin.togglePreviewSize();
  },
  chooseFile: (n) => {
    window.TopolPlugin.chooseFile(n);
  },
  undo: () => {
    window.TopolPlugin.undo();
  },
  redo: () => {
    window.TopolPlugin.redo();
  },
  destroy: () => {
    window.TopolPlugin.destroy();
  },
  setSavedBlocks: (n) => {
    window.TopolPlugin.setSavedBlocks(n);
  },
  setPreviewHTML: (n) => {
    window.TopolPlugin.setPreviewHTML(n);
  },
  createNotification: (n) => {
    window.TopolPlugin.createNotification(n);
  },
  setActiveMembers: (n) => {
    window.TopolPlugin.setActiveMembers(n);
  },
  changeEmailToMobile: () => {
    window.TopolPlugin.changeEmailToMobile();
  },
  changeEmailToDesktop: () => {
    window.TopolPlugin.changeEmailToDesktop();
  },
  toggleBlocksAndStructuresVisibility: () => {
    window.TopolPlugin.toggleBlocksAndStructuresVisibility();
  },
  updateCustomBlockContent: (n) => {
    window.TopolPlugin.updateCustomBlockContent(n);
  },
  refreshComments: (n) => {
    window.TopolPlugin.refreshComments(n);
  },
  refreshSyncedRows: () => {
    window.TopolPlugin.refreshSyncedRows();
  },
  openPremadeTemplatesSelection: () => {
    window.TopolPlugin.openPremadeTemplatesSelection();
  },
  updateApiAuthorizationHeader: (n) => {
    window.TopolPlugin.updateApiAuthorizationHeader(n);
  },
  setTemplateName: (n) => {
    window.TopolPlugin.setTemplateName(n);
  }
}, Rr = "editor";
let K = !1, X = !1;
function Pr(n) {
  const u = () => {
    const g = {
      onSave(a, f) {
        n.onSave !== void 0 && n.onSave(a, f);
      },
      onSaveAndClose(a, f) {
        n.onSaveAndClose !== void 0 && n.onSaveAndClose(a, f);
      },
      onTestSend(a, f, b) {
        n.onTestSend !== void 0 && n.onTestSend(a, f, b);
      },
      onOpenFileManager() {
        n.onOpenFileManager !== void 0 && n.onOpenFileManager();
      },
      onLoaded() {
        n.onLoaded !== void 0 && n.onLoaded();
      },
      onBlockSave(a) {
        n.onBlockSave !== void 0 && n.onBlockSave(a);
      },
      onBlockRemove(a) {
        n.onBlockRemove !== void 0 && n.onBlockRemove(a);
      },
      onBlockEdit(a) {
        n.onBlockEdit !== void 0 && n.onBlockEdit(a);
      },
      onInit() {
        n.onInit !== void 0 && n.onInit(), K = !1, X = !0;
      },
      onUndoChange(a) {
        n.onUndoChange !== void 0 && n.onUndoChange(a);
      },
      onRedoChange(a) {
        n.onRedoChange !== void 0 && n.onRedoChange(a);
      },
      onPreview(a) {
        n.onPreview !== void 0 && n.onPreview(a);
      },
      onAlert(a) {
        n.onAlert !== void 0 && n.onAlert(a);
      },
      onClose() {
        n.onClose !== void 0 && n.onClose();
      },
      onEdittedWithoutSaveChanged(a) {
        n.onEdittedWithoutSaveChanged !== void 0 && n.onEdittedWithoutSaveChanged(a);
      },
      onOpenCustomBlockDialog(a) {
        n.onOpenCustomBlockDialog !== void 0 && n.onOpenCustomBlockDialog(a);
      },
      onTemplateRename(a) {
        n.onTemplateRename !== void 0 && n.onTemplateRename(a);
      },
      updateTestingEmailAddresses(a) {
        n.updateTestingEmailAddresses !== void 0 && n.updateTestingEmailAddresses(a);
      },
      onError(a, f) {
        n.onError !== void 0 && n.onError(a, f);
      }
    };
    return { id: "#" + Rr, ...n.options, callbacks: { ...g } };
  };
  return cr(() => (K || (async () => {
    K = !0;
    const a = u();
    await Ce.init(a, { stage: n.stage || "production" });
  })(), () => {
    X && (Ce.destroy(), X = !1);
  }), []), /* @__PURE__ */ vr.jsx(
    "div",
    {
      id: "editor",
      style: { position: "absolute", height: "100vh", width: "100%" }
    }
  );
}
export {
  Ce as TopolPlugin,
  Pr as default
};
